/* pamela-panels-library.js
   Panels/Frames Library UI — dock on RIGHT (Two-level tabs)

   ✅ Two-tier tabs:
     - Row 1: Group (Last Name / Name-Dates)
     - Row 2: Subcategory (Floral/Scroll/Ribbon/Rectangle/etc)

   Data it uses:
     window.PAMELA_PANELS (array of items)
       Each item can be:
         { id, name, url, group, subcat }
       OR legacy:
         { id, name, url, category } where category is either:
           - "Floral" (single)
           - "Last Name — Floral" (two-level in one string)

     window.PAMELA_PANELS_TABS (optional, recommended)
       {
         "Last Name": ["Floral","Scroll","Ribbon","Rectangle"],
         "Name/Dates": ["Scroll","Ribbon","Book","Heart","Rectangle"]
       }

   - When opening Panels, it closes Clipart UI (best-effort) so they can't overlap.
   - CRITICAL FIX:
       When dock is closed it is display:none AND pointer-events:none
       so it can NEVER steal Konva drag events.
*/

(function () {
  const DOCK_ID = "pamela-panels-dock";

  // Clipart UI DOM IDs we might need to close/hide
  const CLIPART_UI_IDS = ["pamela-clipart-dock", "pamela-clipart-modal", "pamela-library-modal", "pamela-clipart-drawer"];

  const tryCloseClipartAPIs = () => {
    try {
      if (window.PAMELA_CLIPART_UI && typeof window.PAMELA_CLIPART_UI.close === "function") window.PAMELA_CLIPART_UI.close();
    } catch (_) {}
    try {
      if (window.PAMELA_LIBRARY_UI && typeof window.PAMELA_LIBRARY_UI.close === "function") window.PAMELA_LIBRARY_UI.close();
    } catch (_) {}
    try {
      if (window.PAMELA_CLIPART_DRAWER && typeof window.PAMELA_CLIPART_DRAWER.close === "function") window.PAMELA_CLIPART_DRAWER.close();
    } catch (_) {}
  };

  const hideClipartDOM = () => {
    for (const id of CLIPART_UI_IDS) {
      const el = document.getElementById(id);
      if (!el) continue;
      el.style.display = "none";
      el.style.pointerEvents = "none";
      el.setAttribute("aria-hidden", "true");
    }
  };

  const RAW_ITEMS = () => (Array.isArray(window.PAMELA_PANELS) ? window.PAMELA_PANELS : []);

  // Your intended structure (can be supplied/overridden in registry)
  const TAB_PLAN = () => {
    const t = window.PAMELA_PANELS_TABS;
    if (t && typeof t === "object") return t;

    // Safe defaults if you forget to define it
    return {
      "Last Name": ["Book", "Heart", "Misc", "Oval", "Rectangle", "Ribbon", "Scroll"],
      "Name/Dates": ["Book", "Heart", "Misc", "Oval", "Rectangle", "Ribbon", "Scroll"],
      "Verse": ["Book", "Heart", "Misc", "Oval", "Rectangle", "Ribbon", "Scroll"],
    };
  };

  function norm(s) {
    return String(s || "").trim();
  }

  // Accept: item.group + item.subcat (preferred)
  // OR: item.category = "Last Name — Floral" (legacy combined label)
  // OR: item.category = "Floral" (single label)
  function normalizeItem(it) {
    const out = Object.assign({}, it);

    let group = norm(out.group);
    let subcat = norm(out.subcat);

    const cat = norm(out.category);

    if ((!group || !subcat) && cat && cat.includes("—")) {
      const parts = cat.split("—").map((x) => norm(x));
      if (!group) group = parts[0] || "";
      if (!subcat) subcat = parts[1] || "";
    }

    // If still missing group/subcat, treat as a simple "Unsorted" group
    if (!group) group = "Panels";
    if (!subcat) subcat = cat || "General";

    out.group = group;
    out.subcat = subcat;
    out.url = norm(out.url);
    out.thumbUrl = norm(out.thumbUrl);

    return out;
  }

  function buildIndex(items) {
    const byGroup = {};
    const byGroupSub = {};

    items.forEach((raw) => {
      const it = normalizeItem(raw);
      if (!it.url) return;

      (byGroup[it.group] ||= []).push(it);
      const k = it.group + "||" + it.subcat;
      (byGroupSub[k] ||= []).push(it);
    });

    return { byGroup, byGroupSub };
  }

  function getEditorLayout() {
    try {
      const globalLayout = String(window.PAMELA_EDITOR_LAYOUT || "").trim().toLowerCase();
      if (globalLayout) return globalLayout;

      const candidates = [
        window.pamelaEditor,
        window.pamelaMonumentEditor,
        window.editor,
        window.PAMELA_EDITOR,
        window.__PAMELA_EDITOR__,
      ].filter(Boolean);

      for (const ed of candidates) {
        const layout = String(ed?.layout || ed?.monumentLayout || "").trim().toLowerCase();
        if (layout) return layout;
      }
    } catch (_) {}

    try {
      return String(new URLSearchParams(window.location.search).get("layout") || "").trim().toLowerCase();
    } catch (_) {
      return "";
    }
  }

  function isSingleLayout() {
    if (getEditorLayout() === "single") return true;

    try {
      const addLastNameBtn = document.getElementById("pamela-add-lastname");
      if (addLastNameBtn) {
        const style = window.getComputedStyle ? window.getComputedStyle(addLastNameBtn) : null;
        if (addLastNameBtn.style.display === "none" || style?.display === "none") return true;
      }
    } catch (_) {}

    return false;
  }

  function getAvailableGroups(plan, idx) {
    return ["Last Name", "Name/Dates", "Verse"].filter((g) => {
      if (isSingleLayout() && g === "Last Name") return false;
      return true;
    });
  }

  function pillButton(label, isActive, onClick) {
    const b = document.createElement("button");
    b.type = "button";
    b.textContent = label;

    b.style.cssText =
      "padding:6px 10px;border-radius:999px;border:1px solid rgba(0,0,0,0.2);" +
      (isActive ? "background:#111;color:#fff;" : "background:#fff;color:#111;") +
      "font-weight:900;font-size:12px;cursor:pointer;";

    b.addEventListener("click", onClick);
    return b;
  }

  function openPrebuiltFrames() {
    const openClipartPanels = () => {
      window.__PAMELA_CLIPART_REQUESTED_CATEGORY = "panels";

      if (window.PAMELA_CLIPART_UI && typeof window.PAMELA_CLIPART_UI.openToCategory === "function") {
        window.PAMELA_CLIPART_UI.openToCategory("panels");
        return true;
      }

      const clipartBtn = document.getElementById("pamela-view-clipart");
      if (clipartBtn) {
        clipartBtn.click();
        return true;
      }

      console.warn("Clipart library is not available.");
      return false;
    };

    if (openClipartPanels()) close();
  }

  let dock = null;
  let searchWrap = null;
  let searchInput = null;

  let groupWrap = null;
  let subWrap = null;
  let grid = null;

  let state = {
    group: "",   // e.g. "Last Name"
    sub: "All",  // e.g. "Floral"
    q: "",
  };

  function ensureDock() {
    dock = document.getElementById(DOCK_ID);
    if (dock) return dock;

    dock = document.createElement("div");
    dock.id = DOCK_ID;

    dock.style.position = "fixed";
    dock.style.top = "0";
    dock.style.right = "0";
    dock.style.width = "360px";
    dock.style.maxWidth = "92vw";
    dock.style.height = "100vh";
    dock.style.boxSizing = "border-box";
    dock.style.background = "#fff";
    dock.style.borderLeft = "1px solid rgba(0,0,0,0.15)";
    dock.style.boxShadow = "0 10px 40px rgba(0,0,0,0.25)";
    dock.style.zIndex = "999999";
    dock.style.fontFamily = "system-ui,-apple-system,Segoe UI,Roboto,Arial";
    dock.style.color = "#111";

    // start closed and NON-BLOCKING
    dock.style.display = "none";
    dock.style.pointerEvents = "none";
    dock.setAttribute("aria-hidden", "true");

    dock.innerHTML = "";

    // Header
    const headerRow = document.createElement("div");
    headerRow.style.cssText = "display:flex;align-items:center;justify-content:space-between;gap:10px;padding:12px 12px 8px 12px;";

    const title = document.createElement("div");
    title.textContent = "Panels / Frames";
    title.style.cssText = "font-weight:900;font-size:16px;letter-spacing:0.2px;";

    const closeBtn = document.createElement("button");
    closeBtn.type = "button";
    closeBtn.textContent = "✕";
    closeBtn.setAttribute("aria-label", "Close Panels");
    closeBtn.style.cssText =
      "width:36px;height:36px;border-radius:10px;border:1px solid rgba(0,0,0,0.2);" +
      "background:#fff;color:#111;font-weight:900;cursor:pointer;";

    closeBtn.addEventListener("click", () => close());

    headerRow.appendChild(title);
    headerRow.appendChild(closeBtn);
    dock.appendChild(headerRow);

    // Search
    searchWrap = document.createElement("div");
    searchWrap.style.cssText = "flex:0 0 100%;padding:0;margin-top:8px;";

    searchInput = document.createElement("input");
    searchInput.type = "search";
    searchInput.placeholder = "Search panels…";
    searchInput.style.cssText =
      "width:100%;padding:10px 12px;border-radius:12px;border:1px solid rgba(0,0,0,0.2);" +
      "font-weight:700;font-size:13px;outline:none;";

    searchInput.addEventListener("input", () => {
      state.q = String(searchInput.value || "");
      renderGrid();
    });

    searchWrap.appendChild(searchInput);

    const guideLine = document.createElement("div");
    guideLine.textContent = "Choose frames to enhance your lettering.";
    guideLine.style.cssText =
      "padding:0 12px 8px 12px;font-weight:800;font-size:13px;line-height:1.35;color:#222;";
    dock.appendChild(guideLine);

    const graniteNote = document.createElement("div");
    graniteNote.textContent = "For longest lasting readability, it is highly recommended to use a frame around all names and dates on light granite colors.";
    graniteNote.style.cssText =
      "padding:0 12px 14px 12px;font-weight:800;font-size:13px;line-height:1.45;color:#444;";
    dock.appendChild(graniteNote);

    // Make the dock a flex column and let the full drawer scroll.
    dock.style.display = "none";
    dock.style.pointerEvents = "none";
    dock.setAttribute("aria-hidden", "true");
    dock.style.display = "flex";
    dock.style.flexDirection = "column";
    dock.style.overflowY = "auto";
    dock.style.overflowX = "hidden";

    // Group tabs (Row 1) — main frame types
    groupWrap = document.createElement("div");
    groupWrap.style.cssText =
      "display:flex;flex-wrap:wrap;gap:8px;padding:0 12px 10px 12px;border-bottom:2px solid rgba(0,0,0,0.18);margin-bottom:12px;flex:0 0 auto;";

    dock.appendChild(groupWrap);

    // Sub tabs (Row 2)
    subWrap = document.createElement("div");
    subWrap.style.cssText =
      "display:flex;flex-wrap:wrap;gap:8px;padding:0 12px 12px 12px;border-bottom:1px solid rgba(0,0,0,0.08);flex:0 0 auto;";

    dock.appendChild(subWrap);

    // Grid
    grid = document.createElement("div");
    grid.style.cssText =
      "padding:12px;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;" +
      "overflow:visible;flex:0 0 auto;min-height:0;";
    dock.appendChild(grid);

    // Stop events leaking to canvas behind dock
    dock.addEventListener("pointerdown", (e) => e.stopPropagation());
    dock.addEventListener("pointermove", (e) => e.stopPropagation());
    dock.addEventListener("pointerup", (e) => e.stopPropagation());
    dock.addEventListener("wheel", (e) => e.stopPropagation());

    document.body.appendChild(dock);

    // Initialize defaults
    initStateIfNeeded();
    renderTabs();
    renderGrid();

    return dock;
  }

  function setDockOpen(open) {
    ensureDock();

    if (open) {
      dock.style.display = "flex";
      dock.style.pointerEvents = "auto";
      dock.setAttribute("aria-hidden", "false");

      dock.style.left = "auto";
      dock.style.bottom = "auto";
      dock.style.top = "0";
      dock.style.right = "0";
      dock.style.height = "100vh";
      dock.style.width = dock.style.width || "360px";
      dock.style.maxWidth = dock.style.maxWidth || "92vw";
    } else {
      try {
        if (dock.contains(document.activeElement)) document.activeElement.blur();
      } catch (_) {}
      dock.style.display = "none";
      dock.style.pointerEvents = "none";
      dock.setAttribute("aria-hidden", "true");
    }
  }

  function isOpen() {
    return !!dock && dock.style.display !== "none";
  }

  function getAllNormalizedItems() {
    return RAW_ITEMS().map(normalizeItem).filter((it) => it.url);
  }

  function initStateIfNeeded() {
    const plan = TAB_PLAN();
    const idx = buildIndex(getAllNormalizedItems());
    const groups = getAvailableGroups(plan, idx);

    if (!state.group) {
      // Prefer "Last Name" if present
      state.group = groups.includes("Last Name") ? "Last Name" : (groups[0] || "Panels");
    }

    // If the selected group isn't in plan, keep it but subcats will be inferred
    if (!state.sub) state.sub = "All";
  }

  function getSubcatsForGroup(group, itemsIndex) {
    const plan = TAB_PLAN();
    const planned = Array.isArray(plan[group]) ? plan[group] : null;
    if (planned && planned.length) return planned;

    // Fallback: infer from actual items
    const inferred = new Set();
    const gItems = itemsIndex.byGroup[group] || [];
    gItems.forEach((it) => inferred.add(it.subcat));
    return Array.from(inferred).sort((a, b) => a.localeCompare(b));
  }

  function renderTabs() {
    if (!groupWrap || !subWrap) return;

    const items = getAllNormalizedItems();
    const idx = buildIndex(items);

    const plan = TAB_PLAN();
    const plannedGroups = Object.keys(plan);

    // Show groups that are either planned OR present in items
    const groups = getAvailableGroups(plan, idx);

    // Keep your preferred order: planned first, then the rest
    groups.sort((a, b) => {
      const ai = plannedGroups.indexOf(a);
      const bi = plannedGroups.indexOf(b);
      if (ai !== -1 && bi !== -1) return ai - bi;
      if (ai !== -1) return -1;
      if (bi !== -1) return 1;
      return a.localeCompare(b);
    });

    // If current group vanished, reset
    if (!groups.includes(state.group)) state.group = groups[0] || "Panels";

    // --- Row 1: Groups
    groupWrap.innerHTML = "";
    const fieldCss = "display:flex;flex-direction:column;gap:5px;font-size:11px;font-weight:900;color:#555;";
    const selectCss =
      "width:100%;height:42px;box-sizing:border-box;padding:0 34px 0 12px;border-radius:14px;" +
      "border:1px solid rgba(0,0,0,.15);background:#fff;color:#111;font-weight:900;font-size:14px;cursor:pointer;";

    const frameTypeField = document.createElement("label");
    frameTypeField.style.cssText = fieldCss + "flex:1 1 100%;";
    const frameTypeLabel = document.createElement("span");
    frameTypeLabel.textContent = "Frame Type";
    const frameTypeSelect = document.createElement("select");
    frameTypeSelect.setAttribute("aria-label", "Frame type");
    frameTypeSelect.style.cssText = selectCss;
    frameTypeSelect.appendChild(new Option("Traditional Frames", "traditional"));
    frameTypeSelect.appendChild(new Option("Contemporary Frames", "contemporary"));
    frameTypeSelect.value = "traditional";
    frameTypeSelect.addEventListener("change", () => {
      if (frameTypeSelect.value === "contemporary") openPrebuiltFrames();
    });
    frameTypeField.appendChild(frameTypeLabel);
    frameTypeField.appendChild(frameTypeSelect);
    groupWrap.appendChild(frameTypeField);

    const categoryField = document.createElement("label");
    categoryField.style.cssText = fieldCss + "flex:1 1 150px;min-width:0;";
    const categoryLabel = document.createElement("span");
    categoryLabel.textContent = "Category";
    const categorySelect = document.createElement("select");
    categorySelect.setAttribute("aria-label", "Panel category");
    categorySelect.style.cssText = selectCss;

    groups.forEach((g) => {
      const label = g === "Name/Dates" ? "Name/Date" : g;
      categorySelect.appendChild(new Option(label, g));
    });

    categorySelect.value = state.group;
    categorySelect.addEventListener("change", () => {
      state.group = categorySelect.value;
      state.sub = "All";
      renderTabs();
      renderGrid();
    });
    categoryField.appendChild(categoryLabel);
    categoryField.appendChild(categorySelect);
    groupWrap.appendChild(categoryField);

    const subField = document.createElement("label");
    subField.style.cssText = fieldCss + "flex:1 1 150px;min-width:0;";
    const subLabel = document.createElement("span");
    subLabel.textContent = "Subcategory";
    const subSelect = document.createElement("select");
    subSelect.setAttribute("aria-label", "Panel subcategory");
    subSelect.style.cssText = selectCss;

    const resizeNote = document.createElement("div");
    const resizeCopy = state.group === "Last Name"
      ? "Last Name frames resize wider or narrower."
      : "These frames resize freely with handles.";
    resizeNote.textContent = resizeCopy;
    resizeNote.style.cssText = "flex:0 0 100%;font-weight:800;font-size:11px;line-height:1.3;color:#555;margin-top:-2px;";

    // --- Row 2: Subcats (for active group)
    const subs = getSubcatsForGroup(state.group, idx);

    subWrap.innerHTML = "";
    subWrap.style.display = "none";

    subSelect.appendChild(new Option("All", "All"));

    subs.forEach((s) => {
      subSelect.appendChild(new Option(s === "Misc" ? "Misc." : s, s));
    });

    // If current subcat isn't valid anymore, fall back to All
    if (state.sub !== "All" && !subs.includes(state.sub)) state.sub = "All";
    subSelect.value = state.sub;
    subSelect.addEventListener("change", () => {
      state.sub = subSelect.value;
      renderGrid();
    });
    subField.appendChild(subLabel);
    subField.appendChild(subSelect);
    groupWrap.appendChild(subField);
    groupWrap.appendChild(resizeNote);

    if (searchWrap) groupWrap.appendChild(searchWrap);
  }

  function matches(it) {
    const q = String(state.q || "").trim().toLowerCase();
    if (state.group && it.group !== state.group) return false;
    if (state.sub && state.sub !== "All" && it.subcat !== state.sub) return false;
    if (!q) return true;

    const hay = `${it.name || ""} ${it.id || ""} ${it.group || ""} ${it.subcat || ""}`.toLowerCase();
    return hay.includes(q);
  }

  function renderGrid() {
    if (!grid) return;

    const items = getAllNormalizedItems().filter(matches);

    grid.innerHTML = "";

    if (!items.length) {
      const empty = document.createElement("div");
      empty.textContent = "No panels found.";
      empty.style.cssText = "grid-column:1 / -1;opacity:0.65;font-weight:800;padding:8px;";
      grid.appendChild(empty);
      return;
    }

    items.forEach((it) => {
      const card = document.createElement("button");
      card.type = "button";
      card.style.cssText =
        "display:flex;flex-direction:column;align-items:stretch;gap:8px;" +
        "border:1px solid rgba(0,0,0,0.15);border-radius:14px;background:#fff;" +
        "padding:10px;cursor:pointer;text-align:left;";

      // Prefer the small server-generated thumbnail (see cm-editor-server's
      // Refresh Thumbnails button on /admin/svg-upload) -- items not yet
      // processed fall back to the original full file, same pattern as the
      // clipart picker.
      const img = document.createElement("img");
      img.alt = it.name || it.id || "Panel";
      img.loading = "lazy";
      img.src = it.thumbUrl || it.url || "";
      img.style.cssText =
        "width:100%;height:130px;object-fit:contain;background:#fafafa;border-radius:12px;" +
        "border:1px solid rgba(0,0,0,0.08);";

      const label = document.createElement("div");
      label.textContent = it.name || it.id || "Panel";
      label.style.cssText = "font-weight:900;font-size:12px;line-height:1.15;opacity:0.95;";

      const sub = document.createElement("div");
      sub.textContent = `${it.group} • ${it.subcat}`;
      sub.style.cssText = "font-weight:800;font-size:11px;opacity:0.55;";

      card.appendChild(img);
      card.appendChild(label);
      card.appendChild(sub);

      card.addEventListener("click", () => {
        try {
          if (typeof window.PAMELA_ADD_PANEL_TO_STAGE === "function") {
            window.PAMELA_ADD_PANEL_TO_STAGE(it);
          } else {
            console.warn("PAMELA_ADD_PANEL_TO_STAGE is not available on window.");
          }
        } catch (e) {
          console.error(e);
        }
      });

      grid.appendChild(card);
    });
  }

  // -----------------------------
  // Public API
  // -----------------------------
  function open() {
    ensureDock();

    // Close clipart/library UI so it can't overlap and steal pointer events
    tryCloseClipartAPIs();
    hideClipartDOM();

    initStateIfNeeded();
    renderTabs();
    if (isSingleLayout() && state.group === "Last Name") {
      state.group = "";
      initStateIfNeeded();
      renderTabs();
    }
    renderGrid();

    setDockOpen(true);

    try {
      if (searchInput) searchInput.focus();
    } catch (_) {}
  }

  function close() {
    setDockOpen(false);
  }

  function toggle() {
    if (isOpen()) close();
    else open();
  }

  window.PAMELA_PANELS_UI = {
    open,
    close,
    toggle,
    isOpen,
  };
})();
